var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPerson = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 0.333984C4.15901 0.333984 2.66663 1.82637 2.66663 3.66732C2.66663 5.50827 4.15901 7.00065 5.99996 7.00065C7.84091 7.00065 9.33329 5.50827 9.33329 3.66732C9.33329 1.82637 7.84091 0.333984 5.99996 0.333984Z",
    fill: "#BFBBCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 8.33398C2.44928 8.33398 1.60143 8.68517 0.976311 9.3103C0.35119 9.93542 0 10.7833 0 11.6673V13.0007C0 13.3688 0.298477 13.6673 0.666667 13.6673H11.3333C11.7015 13.6673 12 13.3688 12 13.0007V11.6673C12 10.7833 11.6488 9.93542 11.0237 9.3103C10.3986 8.68517 9.55072 8.33398 8.66667 8.33398H3.33333Z",
    fill: "#BFBBCF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPerson);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person.209d640b028cd3c987b73570ebcd9679.svg";